// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EQd3","right":"styles_right__2H3it"};